<template>
  <div>
    <DatePicker
      v-model="date"
      :is-expanded="$screens({ default: true, lg: false })"
      color="gray"
      title-position="left"
      :mode="mode"
      :min-date="fromToday ? todayDate : null"
      :timezone="timezone"
    >
      <template v-slot="{ inputEvents }">
        <div
          v-on="inputEvents"
          class="flex items-center justify-between w-full md:w-5/6 h-10  px-4 border-gray-200 border-2 rounded-lg mb-4"
        >
          <span class="text-sm"><span :class="date ? 'font-bold' : 'font-light'">{{ date ? displayDate : text }}</span>  {{ date ? displayTime : '' }}</span>
          <CalendarIcon />
        </div>
      </template>
    </DatePicker>
  </div>
</template>

<script>
import dayjs from "dayjs";

import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import CalendarIcon from "@/components/svg/Calendar";

var utc = require("dayjs/plugin/utc");
var timezone = require('dayjs/plugin/timezone');
var advancedFormat = require('dayjs/plugin/advancedFormat');

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export default {
  name: "DatePickerInput",

  props: {
    text: {
        type: String,
        default: "Choose Date and Time"
    },

    initialDate: {
        type: String,
        default: ""
    },

    fromToday: {
      type: Boolean,
      default: false
    },

    mode: {
      type: String,
      default: 'datetime'
    }
  },

  components: {
    CalendarIcon,
    Calendar,
    DatePicker
  },

  data() {
    return {
      date: this.initialDate,
      timezone: ""
    };
  },

  computed: {
    displayDate: function() {
      if(this.mode === 'datetime')
        return dayjs(this.date).format('MMM D YYYY');
      return dayjs(this.date).format('YYYY/MM/DD');
    },

    displayTime: function() {
      if(this.mode === 'datetime')
        return dayjs(this.date).format('h:mma z');
      return '';
    },

    todayDate: function() {
      return dayjs().$d;
    }
  },

  watch: {
    date: function() {
      this.$emit("dateChanged", dayjs(this.date).format('YYYY/MM/DD HH:mm:ss ZZ'));
    }
  }
};
</script>
<style>
.vc-pane {
  min-width: 300px !important;
}
.vc-select select{
  appearance:none !important;
  background: transparent;
}
</style>
